import React from 'react';
import PropTypes from 'prop-types';
import { Stack, TextField, InputAdornment, MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchAndFilters = ({ searchQuery, onSearch, categoryFilter, onCategoryChange, equipmentFilter, onEquipmentChange, categories, equipment }) => (
  <div style={{marginBottom: '20px'}}>
    <TextField
      fullWidth
      variant="outlined"
      placeholder="Pronađi vježbe..."
      value={searchQuery}
      onChange={(e) => onSearch(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />

    <Stack direction="row" spacing={2} mt={2}>
      <TextField
        label="Kategorije"
        select
        value={categoryFilter}
        onChange={(e) => onCategoryChange(e.target.value)}
        fullWidth
      >
        <MenuItem value="">Sve</MenuItem>
        {categories.map((category, index) => (
          <MenuItem key={index} value={category}>
            {category}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        label="Oprema"
        select
        value={equipmentFilter}
        onChange={(e) => onEquipmentChange(e.target.value)}
        fullWidth
      >
        <MenuItem value="">Sve</MenuItem>
        {equipment.map((item, index) => (
          <MenuItem key={index} value={item}>
            {item}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  </div>
);

SearchAndFilters.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  categoryFilter: PropTypes.string.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  equipmentFilter: PropTypes.string.isRequired,
  onEquipmentChange: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  equipment: PropTypes.array.isRequired,
};

export default SearchAndFilters;
